"use strict";

import React from "react";
import Wprr from "wprr";

export default class BlueBackgroundArea extends Wprr.Layout {
	
	/**
	 * Constructor
	 */
	_construct() {
		super._construct();
	}
	
	_getLayout(aSlots) {

		let color = this.getFirstInput(Wprr.sourceReference("blockData", "color"));
		
		return <div className="blue-background blue-background-text-color">
			<div className="spacing double" />
				{aSlots.default(React.createElement(Wprr.ContentsAndInjectedComponents, {content: Wprr.sourceReference("blockData", "innerMarkup")}))}
			<div className="spacing double" />
		</div>;
	}
	
	static getWpAdminEditor() {
		console.log("getWpAdminEditor");
		
		let dataSettings = {
			
		};
		
		return React.createElement("div", null,
			React.createElement(Wprr.FlexRow, {className: "small-item-spacing vertically-center-items", itemClasses: "flex-resize,flex-no-resize,flex-resize"},
				React.createElement("hr", { className: "line no-margin"}),
				React.createElement("div", null, Wprr.translateText("Background area")),
				React.createElement("hr", {className: "line no-margin"})
			),
			React.createElement(wp.editor.InnerBlocks, null),
			React.createElement(Wprr.FlexRow, {className: "small-item-spacing vertically-center-items", itemClasses: "flex-resize,flex-no-resize,flex-resize"},
				React.createElement("hr", {className: "line no-margin"}),
				React.createElement("div", null, Wprr.translateText("End:"), " ", Wprr.translateText("Background area")),
				React.createElement("hr", {className: "line no-margin"})
			)
		);
	}
}